import React from 'react'
import R from 'ramda'
import AppRow from './AppRow'
import { Row, HeaderRow, Col } from './components'

const urlWidth = '350px'
const toAppRows = save =>
  R.compose(
    R.map(app => (
      <AppRow
        key={app.appName}
        Row={Row}
        CellWrapper={Col}
        dataWidth={urlWidth}
        save={save}
        {...app}
      />
    )),
    R.sortBy(d => d.appName)
  )

const App = ({ apps, save }) => (
  <div>
    {apps.length > 0 && (
      <HeaderRow>
        <Col>AppName</Col>
        <Col width={urlWidth}>Base URL</Col>
        <Col grow="1" width="240px">
          Api-Key
        </Col>
      </HeaderRow>
    )}
    {toAppRows(save)(apps)}
  </div>
)

export default App
